import React, { useEffect, useMemo, useState } from 'react';
import { Card, Stack, Typography } from '@mui/material';
import TabsCurrencies from '../../../../../components/widgets/TabsCurrencies';
import { useTranslation } from 'react-i18next';
import CusAutocompleteDragDrop from '../../../../../components/material-ui/custom_autocomplete_dnd/CusAutocompleteDragDrop';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import Scrollbar from '../../../../../components/custom-scroll/Scrollbar';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import { useAppSelector } from '../../../../../store';
import LoaderContainer from '../../../../../components/material-ui/loader_container/LoaderContainer';

export default function CascadeCurrency({ cascade, casinoId, loader }) {
  const { t } = useTranslation();
  const { isShortHeight, isMobile } = useBootstrapSize();
  const { successToast } = useToast();
  const mainGroupCurrency = useAppSelector((state) => state.user.group.main.currency);

  const [currency, setCurrency] = useState(mainGroupCurrency);
  const [cascadeInfo, setCascadeInfo] = useState({});
  const [structFields, setStructFields] = useState([]);
  const [currencies, setCurrencies] = useState(null);

  const gatesInfo = cascade.gateInfo;
  const gatesReactId = gatesInfo?.reactId;

  const LABEL_BY_ID = {
    qrc: 'By QR code',
    card: 'To the card',
    sbp: 'Via SBP',
    sber: 'To Sberbank account',
    trans: 'Cross-border transfer',
    tsng: 'By phone CIS',
    acc: 'By account number',
    alpha: 'AlfaBank - AlfaBank',
    ozon: 'OzonBank - OzonBank',
    crypto: 'By crypto address',
    mobc: 'Mobile commerce'
  };

  const { fields, structField, usedCurrencies } = useMemo(() => {
    const fields = {};
    const structField = [];
    const usedCurrencies = new Set();
    if (!currency) return { fields, structField, usedCurrencies: null };

    for (let gate in gatesInfo) {
      if (gate == 'reactId') continue;

      const gateInfo = gatesInfo[gate];
      for (let methodCurrency in gateInfo.methods) {
        usedCurrencies.add(methodCurrency);
        const types = gateInfo.methods[currency];

        if (methodCurrency != currency) continue;
        if (!types || !types.length) continue;

        types.forEach((type) => {
          if (!fields[type]) fields[type] = [];
          fields[type].push({ label: gateInfo.name, value: gate });
        });
      }
    }

    Object.keys(fields).map((type) => {
      structField.push({ id: type, label: LABEL_BY_ID[type] || type });
    });

    return { fields, structField, usedCurrencies: [...usedCurrencies] };
  }, [gatesReactId, currency]);

  useEffect(() => {
    setStructFields(structField);
  }, [structField]);

  useEffect(() => {
    if (usedCurrencies && usedCurrencies?.length) setCurrencies(usedCurrencies);
  }, [usedCurrencies]);

  useEffect(() => {
    if (!gatesReactId) return;
    let newCascadeInfo = cascade.cascade;
    if (!newCascadeInfo) return;

    if (Array.isArray(newCascadeInfo)) {
      if (newCascadeInfo.length === 0) {
        newCascadeInfo = {};
      } else {
        console.error('получен массив вместо объекта');
      }
    }
    setCascadeInfo(newCascadeInfo);
  }, [gatesReactId]);

  useEffect(() => {
    if (!currencies?.length) return;
    if (currencies?.includes(currency)) return;

    setCurrency((prev) => currencies[0]);
  }, [currencies]);

  useEffect(() => {
    setCurrency((prev) => prev || mainGroupCurrency);
  }, [mainGroupCurrency]);

  const onSaveClick = () => {
    API_CASINO.cascade
      .set({ casinoId, cascade: cascadeInfo })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  const optionsById = fields;

  return (
    <LoaderContainer loader={loader} boxSx={{ height: 400 }}>
      <ShowContainer
        condition={currencies?.length}
        plug={
          <Typography sx={{ mt: 2 }}>{t('there are no available gateways to fill')}</Typography>
        }>
        <Stack gap={2} height={'100%'}>
          <Stack gap={1} height={'100%'}>
            <TabsCurrencies
              customCurrencies={currencies}
              currency={currency}
              setCurrency={setCurrency}
            />
            <Scrollbar
              sx={{
                maxHeight: isShortHeight || isMobile ? undefined : 'calc(100svh - 355px)',
                height: '100%'
              }}
              alsoMobile>
              <Stack gap={1}>
                {structFields.map((el) => {
                  const values = cascadeInfo[el.id]?.[currency]?.split(',') || [];
                  const options = optionsById[el.id] || [];

                  const displayValues = values
                    .map((value) => options.find((el) => el.value === value))
                    .filter(Boolean);

                  return (
                    <ShowContainer condition={options.length} key={currency + el.id}>
                      <CusAutocompleteDragDrop
                        key={currency + el.id}
                        id={el.id}
                        values={displayValues}
                        label={
                          <Typography fontWeight={700}>
                            {t(el.label)} ({el.id})
                          </Typography>
                        }
                        multi
                        onChange={(val) =>
                          setCascadeInfo((prev) => {
                            const prevInfo = JSON.parse(JSON.stringify(prev));
                            console.log('prevInfo', prevInfo);

                            if (!prevInfo[el.id]) prevInfo[el.id] = {};
                            const listOnlyValue = val.map((el) => el.value);
                            prevInfo[el.id][currency] = listOnlyValue.join(',');
                            return prevInfo;
                          })
                        }
                        options={options}
                      />
                    </ShowContainer>
                  );
                })}
              </Stack>
            </Scrollbar>
          </Stack>
          <CasinoBtnSave onClick={onSaveClick} />
        </Stack>
      </ShowContainer>
    </LoaderContainer>
  );
}
